import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomButton } from 'src/components/ui'
import { useTermsOfUse } from 'src/zustand/stores/termsOfUse.store'

import DocumentationIcon from './DocumentationIcon/DocumentationIcon'
import styles from './TermsOfUse.module.scss'

const TermsOfUse = () => {
  const isActive = useTermsOfUse((state) => state.isActive)
  const toggleTerms = useTermsOfUse((state) => state.toggleTerms)
  const { t } = useTranslation()

  const handleClickAccept = () => {
    localStorage.setItem('termsOfUse', 'true')
    toggleTerms(false)
  }

  return (
    <div className={`${styles.wrapper} ${isActive && styles.active}`}>
      <div className={`${styles.content} ${isActive && styles.active}`}>
        <DocumentationIcon />
        <p className={styles.content_title}>{t('terms_of_use.title')}</p>
        <p className={styles.content_subtitle}>
          {t('terms_of_use.subtitle')} <a href='#'>{t('terms_of_use.link')}</a>
        </p>

        <CustomButton onClick={handleClickAccept} variant='contained' color='violet'>
          {t('terms_of_use.button_text')}
        </CustomButton>
      </div>
    </div>
  )
}

export default TermsOfUse
